<template lang="pug">
  .modal.modal--lg.awards-modal
    .form
      .form__elem
        .form-elem.form-elem_horizontal
          h2.title {{ modalData.title }}
      .form__elem
        .form-elem.form-elem_horizontal
          .form-elem__title Тип
          .form-elem__main
            v-select(
            :multiple="false"
            :disabled="false"
            :clearable="false"
            :searchable="false"
            :filterable="false"
            :options="modalData.awardTypesData"
            label="title"
            v-model="localAwardData.type"
            :value="1"
            @input="onChangeType()"
            )
      .form__elem(
        v-if="showSelectCompetition"
      )
        .form-elem.form-elem_horizontal
          .form-elem__title Конкурс
          .form-elem__main
            v-select(
            :multiple="false"
            :disabled="false"
            :clearable="false"
            :searchable="false"
            :filterable="false"
            :options="modalData.competitions[localAwardData.type.id]"
            label="title"
            v-model="localAwardData.competition"
            :value="1"
            )
      .form__elem(
      v-else-if="!showSelectCompetition"
      )
        .form-elem.form-elem_horizontal
          .form-elem__title Конкурс
          .form-elem__main
            input.input(
            v-model="localAwardData.title"
            maxlength="251"
            )
      .form__elem(
        v-if="hasCompetitions"
      )
        .form-elem.form-elem_horizontal.form-elem_control
          .form-elem__title
          .form-elem__main
            label.input-item
              .input-item__input
                .checkbox
                  input.checkbox__input(
                  type="checkbox"
                  v-model="noCompetition"
                  )
                  .checkbox__icon
              .input-item__body
                .input-item__text Конкурса нет в списке
      .form__elem
        .form-elem.form-elem_horizontal
          .form-elem__title Место
          .form-elem__main
            v-select(
            :multiple="false"
            :disabled="false"
            :clearable="false"
            :searchable="false"
            :filterable="false"
            :options="modalData.awardPlaces"
            label="title"
            v-model="localAwardData.place"
            :value="1"
            )
      .form__elem
        .form-elem.form-elem_horizontal
          .form-elem__title Год
          .form-elem__main
            input.input(
            v-model="currentYear"
            :disabled="true"
            maxlength="4"
            )
      .form__elem
        .form-elem.form-elem_horizontal
          .form-elem__title Копия
          .form-elem__main
            attach-file(
              :attachmentType="'award'"
              :attachments="localAwardData.attachments"
              :fieldname="'attachments'"
              @onChangeAttachments="onChangeAttachments"
              )
      .form__elem.form__elem_button-container
        .form-elem
          .form-elem__main
            button.button(
            @click="$emit('close')"
            )
              .button__text Отмена
            button.button.button_paint-main(
              @click.prevent="onClickAdd"
            )
              .button__text {{ modalData.type === 'new' ? 'Добавить' : 'Обновить' }}

</template>
<script>
import AttachFile from "../../../components/attach-file/attach-file";

export default {
  name: "awards",
  components: {
    AttachFile,
  },
  props: ["modalData"],
  data: () => ({
    localAwardData: {
      type: {
        id: null,
      },
      attachments: [],
      place: null,
      title: "",
      url: "",
      id: "",
      year: null,
      competition: null,
    },
    noCompetition: false,
  }),
  computed: {
    hasCompetitions() {
      if (
        this.modalData.competitions[this.localAwardData.type.id] &&
        this.modalData.competitions[this.localAwardData.type.id].length > 0
      ) {
        return true;
      }
      return false;
    },
    showSelectCompetition() {
      if (
        this.modalData.competitions[this.localAwardData.type.id] &&
        this.modalData.competitions[this.localAwardData.type.id].length > 0 &&
        !this.noCompetition
      ) {
        return true;
      }
      return false;
    },
    // currentAwardType() {
    //   return this.modalData.awardTypesData.find(el => {
    //     return el.id === Number(this.localAwardData.type);
    //   });
    // },
    // vipAwardType() {
    //   if (this.currentAwardType && this.currentAwardType.type) {
    //     return this.currentAwardType.type === 2;
    //   } else {
    //     return true;
    //   }
    // },
    currentYear() {
      let date = new Date();
      return date.getFullYear();
    },
  },
  methods: {
    onChangeType() {
      this.localAwardData.competition = this.modalData.competitions[
        this.localAwardData.type.id
      ][0];
      this.localAwardData.title = "";
    },
    onChangeAttachments(data) {
      this.localAwardData[data.fieldname] = data.value;
      /*let localAwardData = Object.assign({}, this.localAwardData);
      localAwardData.attachments = data.value;
      this.localAwardData = Object.assign({}, localAwardData);*/
    },
    onClickAdd() {
      if (this.noCompetition) {
        this.localAwardData.competition = null;
      }
      this.localAwardData.year = this.currentYear;
      this.modalData.onAdd(
        {
          type: this.localAwardData.type.id,
          attachments: this.localAwardData.attachments,
          place: this.localAwardData.place.id,
          title: this.localAwardData.title,
          url: this.localAwardData.url,
          id: this.localAwardData.id,
          year: this.localAwardData.year,
          competition: this.localAwardData.competition
            ? this.localAwardData.competition.id
            : null,
          noCompetition: this.noCompetition,
        },
        this.modalData.type
      );
    },
  },
  mounted() {
    this.localAwardData.type = this.modalData.awardTypesData[0];
    this.localAwardData.competition = this.modalData.competitions[
      this.localAwardData.type.id
    ][0];
    this.localAwardData.place = this.modalData.awardPlaces[0];
    if (this.modalData.award) {
      this.localAwardData = Object.assign({}, this.modalData.award);
      this.localAwardData.type = this.modalData.award.type;
      if (this.localAwardData.competition) {
        this.localAwardData.competition = this.modalData.award.competition;
      } else {
        this.noCompetition = true;
      }
      this.localAwardData.place = this.modalData.award.place;
    }
  },
};
</script>
